export default __webpack_public_path__ + "static/media/03_ANKO.daffb650.png";